'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HASH_ROUTING_UPDATE_ACCESS_TO_ROUTE = exports.HASH_ROUTING_SWITCH_ROUTE = exports.HASH_ROUTING_SET_NEXT_ROUTE = exports.HASH_ROUTING_INIT_ROUTING = exports.Route = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // REACT


// REDUX


var HASH_ROUTING_SWITCH_ROUTE = 'HASH_ROUTING_SWITCH_ROUTE';
var HASH_ROUTING_SET_NEXT_ROUTE = 'HASH_ROUTING_SET_NEXT_ROUTE';
var HASH_ROUTING_INIT_ROUTING = 'HASH_ROUTING_INIT_ROUTING';
var HASH_ROUTING_UPDATE_ACCESS_TO_ROUTE = 'HASH_ROUTING_UPDATE_ACCESS_TO_ROUTE';

// LIBS

var HashRouterComponent = function (_PureComponent) {
  _inherits(HashRouterComponent, _PureComponent);

  function HashRouterComponent() {
    _classCallCheck(this, HashRouterComponent);

    return _possibleConstructorReturn(this, (HashRouterComponent.__proto__ || Object.getPrototypeOf(HashRouterComponent)).apply(this, arguments));
  }

  _createClass(HashRouterComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var router = {};
      var routeKey = void 0;
      router.routes = {};
      router.active = '';
      router.next = '';
      _react2.default.Children.map(this.props.children, function (child) {
        routeKey = child.props.routeKey.toString();
        router.routes[routeKey] = {};
        router.routes[routeKey].accessible = child.props.initAccess;
      });
      router = _immutable2.default.fromJS(router).merge(this.props.router);
      this.props.initRouting(router);
      this.executeLocation = this.executeLocation.bind(this);
      window.addEventListener('hashchange', this.executeLocation, false);
      this.executeLocation(this.props, router);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (!this.props.router || !(props.router && this.props.router.get('routes').equals(props.router.get('routes')))) {
        this.executeLocation(props);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('hashchange', this.executeLocation);
    }
  }, {
    key: 'executeLocation',
    value: function executeLocation(props, router) {
      if (typeof props.router === 'undefined') {
        props = this.props;
      }
      if (typeof router === 'undefined') {
        router = props.router;
      }
      if (typeof router === 'undefined') {
        return null;
      }

      var _props = props,
          switchRoute = _props.switchRoute,
          setNextRoute = _props.setNextRoute,
          children = _props.children;


      var hash = typeof window.location !== 'undefined' ? window.location.hash : '#';

      var hashPath = hash.split('/');
      if (hashPath[0] === '') {
        hashPath[0] = '#';
      }
      var routesPath = [];
      var scores = [];
      var routes = [];
      var params = [];
      _react2.default.Children.map(children, function (child) {
        var childArray = child.props['hash'].split('/');
        if (childArray[childArray.length - 1] === '') {
          childArray.pop();
        }
        routesPath.push(childArray);
        scores.push(0);
        routes.push(child);
        params.push({});
      });

      var regexParam = /^{(.*)}$/;
      for (var j = 0; j < routesPath.length; j++) {
        for (var i = 0; i < hashPath.length || i < routesPath[j].length; i++) {
          if (hashPath[i] && routesPath[j][i]) {
            if (hashPath[i] === routesPath[j][i]) {
              scores[j] += 100;
            } else if (routesPath[j][i].match(regexParam, '$1')) {
              scores[j] += 1;
              params[j][routesPath[j][i].match(regexParam, '$1')[1]] = hashPath[i];
            } else {
              scores[j] = 0;
              break;
            }
          } else if (!hashPath[i] && routesPath[j][i]) {
            if (!routesPath[j][i].match(regexParam, '$1')) {
              scores[j] = 0;
              break;
            }
          }
        }
      }

      if (routesPath.length > 0) {
        var max = 0;
        var maxId = 0;
        for (var _i = 0; _i < scores.length; _i++) {
          if (scores[_i] > max) {
            max = scores[_i];
            maxId = _i;
          }
        }

        if (routes[maxId].props.routeKey !== router.get('next')) {
          setNextRoute(routes[maxId].props.routeKey, params[maxId]);
        }
        if (routes[maxId].props.routeKey !== router.get('active')) {
          if (router.getIn(['routes', routes[maxId].props.routeKey, 'accessible'])) {
            switchRoute(routes[maxId].props.routeKey, params[maxId]);
          }
        } else {
          if (!router.getIn(['routes', routes[maxId].props.routeKey, 'accessible'])) {
            switchRoute('', null);
          } else if (JSON.stringify(params[maxId]) !== JSON.stringify(router && router.toJS().params || {})) {
            switchRoute(routes[maxId].props.routeKey, params[maxId]);
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          loaderComponent = _props2.loaderComponent,
          router = _props2.router;

      var matchElem = null;

      _react2.default.Children.map(this.props.children, function (child) {
        if (router && router.get('active') === child.props.routeKey.toString()) {
          matchElem = child;
        }
      });

      return matchElem || loaderComponent || _react2.default.createElement(
        'div',
        null,
        'no elements matched'
      );
    }
  }], [{
    key: 'propTypes',
    get: function get() {
      return {
        children: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.object]),
        initRouting: _propTypes.func,
        loaderComponent: _propTypes.object,
        router: _propTypes.object
      };
    }
  }]);

  return HashRouterComponent;
}(_react.PureComponent);

var Route = exports.Route = function (_PureComponent2) {
  _inherits(Route, _PureComponent2);

  function Route() {
    _classCallCheck(this, Route);

    return _possibleConstructorReturn(this, (Route.__proto__ || Object.getPrototypeOf(Route)).apply(this, arguments));
  }

  _createClass(Route, [{
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }], [{
    key: 'propTypes',
    get: function get() {
      return {
        children: _propTypes.object,
        hash: _propTypes.string.isRequired,
        initAccess: _propTypes.bool.isRequired,
        routeKey: _propTypes.string.isRequired
      };
    }
  }]);

  return Route;
}(_react.PureComponent);

var HashRouter = function (_Component) {
  _inherits(HashRouter, _Component);

  function HashRouter() {
    _classCallCheck(this, HashRouter);

    return _possibleConstructorReturn(this, (HashRouter.__proto__ || Object.getPrototypeOf(HashRouter)).apply(this, arguments));
  }

  _createClass(HashRouter, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          routerStatePath = _props3.routerStatePath,
          loaderComponent = _props3.loaderComponent,
          children = _props3.children;


      return _react2.default.createElement((0, _reactRedux.connect)(function (state) {
        var router = state.getIn(routerStatePath.split('.'));
        return { loaderComponent: loaderComponent, router: router };
      }, function (dispatch) {
        return {
          initRouting: function initRouting(router) {
            return dispatch({
              type: HASH_ROUTING_INIT_ROUTING,
              routerStatePath: routerStatePath,
              router: router
            });
          },
          switchRoute: function switchRoute(routeKey, params) {
            return dispatch({
              type: HASH_ROUTING_SWITCH_ROUTE,
              routerStatePath: routerStatePath,
              routeKey: routeKey,
              params: params
            });
          },
          setNextRoute: function setNextRoute(routeKey) {
            return dispatch({
              type: HASH_ROUTING_SET_NEXT_ROUTE,
              routerStatePath: routerStatePath,
              routeKey: routeKey
            });
          }
        };
      })(HashRouterComponent), null, children);
    }
  }], [{
    key: 'propTypes',
    get: function get() {
      return {
        children: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.object]),
        loaderComponent: _propTypes.object,
        routerStatePath: _propTypes.string.isRequired
      };
    }
  }]);

  return HashRouter;
}(_react.Component);

exports.default = HashRouter;
exports.HASH_ROUTING_INIT_ROUTING = HASH_ROUTING_INIT_ROUTING;
exports.HASH_ROUTING_SET_NEXT_ROUTE = HASH_ROUTING_SET_NEXT_ROUTE;
exports.HASH_ROUTING_SWITCH_ROUTE = HASH_ROUTING_SWITCH_ROUTE;
exports.HASH_ROUTING_UPDATE_ACCESS_TO_ROUTE = HASH_ROUTING_UPDATE_ACCESS_TO_ROUTE;